import React from "react";
import TravelMap from "./TravelMap";
import "../../styles/components/profile_page/TravelPanel.css";

/**
 * TravelPanel
 * Simple card summarising where the photographer works and fees.
 *
 * Props:
 * - baseLocation?: string
 * - freeRadiusKm?: number
 * - extraPerMile?: string  // e.g. "£0.45"
 * - maxRangeKm?: number
 * - notes?: string[]
 */
export default function TravelPanel({ travel = {}, isOwner = false, firstName }) {
  const {
    base_location: baseLocation = "United Kingdom",
    free_radius_km: freeRadiusKm = 25,
    extra_travel_per_mile: extraPerMile = "£0.45",
    max_range_km: maxRangeKm,
    notes = []
  } = travel;

  const hasTravelDetails =
    Boolean(baseLocation && String(baseLocation).trim()) ||
    Number(freeRadiusKm) > 0 ||
    Number(extraPerMile) > 0 ||
    typeof maxRangeKm === "number" ||
    notes.length > 0;

  return (
    <section className="travelPanel profile-panel">
      <h3 className="travelPanel__title">Travel & coverage</h3>

      {!hasTravelDetails ? (
        <div className="travelPanel__empty">
          <strong>
            {isOwner
              ? "Travel & coverage details haven't been added yet."
              : `${firstName || "This photographer"} hasn't added travel and coverage details yet.`}
          </strong>
          {isOwner && (
            <p>Add your base location and travel preferences in Edit Profile.</p>
          )}
        </div>
      ) : (
        <>
      <ul className="travelPanel__list">
        <li><strong>Base:</strong> {baseLocation}</li>
        <li><strong>Free radius:</strong> {freeRadiusKm} km</li>
        <li><strong>Extra travel:</strong> {extraPerMile} / mile</li>
        {typeof maxRangeKm === "number" && (
          <li><strong>Max range:</strong> {maxRangeKm} km</li>
        )}
      </ul>

      {notes.length > 0 && (
        <>
          <div className="travelPanel__divider" />
          <ul className="travelPanel__bullets">
            {notes.map((n, i) => <li key={i}>{n}</li>)}
          </ul>
        </>
      )}

      <div className="travelPanel__map">
        <TravelMap
          baseLocation={baseLocation}
          freeRadiusKm={freeRadiusKm}
        />
      </div>
        </>
      )}
    </section>
  );
}